<div class="dialog-container">
  <div class="dialog-heading">
    <h2 mat-dialog-title>{{'examinee.updateExaminee.heading' | translate}}</h2>
    <span class="spacer"></span>
    <div class="btn-close">
      <button mat-icon-button mat-dialog-close aria-label="Close Dialog"><mat-icon>close</mat-icon></button>
    </div>
  </div>
  <mat-dialog-content class="mat-typography">
    <form [formGroup]="examineeDetailsForm" novalidate>
      <div class="form-wrapper">
        <div class="input-wrapper">
          <span class="input-label">
            <label>{{'examinee.updateExaminee.fname' | translate}}</label><span class="required">*</span>
          </span>
          <span class="input-field">
            <input type="text" maxlength="31" class="form-control" formControlName="firstName" (keydown.space)="$event.preventDefault()">

            <div *ngIf="f.firstName.invalid && (f.firstName.dirty || f.firstName.touched)" class="alert alert-danger">
              <div *ngIf="f.firstName.errors?.required">{{'examinee.updateExaminee.errorName1' | translate}}</div>
              <div *ngIf="f.firstName.errors?.minlength">{{'examinee.updateExaminee.errorName2' | translate}}</div>
              <div *ngIf="f.firstName.errors?.maxlength">{{'examinee.updateExaminee.errorName3' | translate}}</div>
              <div *ngIf="f.firstName.errors?.pattern">{{'examinee.updateExaminee.errorName4' | translate}}</div>
            </div>
          </span>
        </div>
        <div class="input-wrapper">
          <span class="input-label">
            <label>{{'examinee.updateExaminee.lname' | translate}}</label><span class="required">*</span>
          </span>
          <span class="input-field">
            <input type="text" maxlength="31" class="form-control" formControlName="lastName" (keydown.space)="$event.preventDefault()">

            <div *ngIf="f.lastName.invalid && (f.lastName.dirty || f.lastName.touched)" class="alert alert-danger">
              <div *ngIf="f.lastName.errors?.required">{{'examinee.updateExaminee.errorLname1' | translate}}</div>
              <div *ngIf="f.lastName.errors?.minlength">{{'examinee.updateExaminee.errorLname2' | translate}}</div>
              <div *ngIf="f.lastName.errors?.maxlength">{{'examinee.updateExaminee.errorLname3' | translate}}</div>
              <div *ngIf="f.lastName.errors?.pattern">{{'examinee.updateExaminee.errorLname4' | translate}}</div>
            </div>
          </span>
        </div>
        <div class="input-wrapper">
          <span class="input-label">
            <label>{{'examinee.updateExaminee.phone' | translate}}</label>
          </span>
          <span class="input-field">
            <input type="text" maxlength="25" class="form-control" formControlName="phone"
              onkeypress='return event.charCode>-48 && event.charCode<=57' (keydown.space)="$event.preventDefault()"
              (blur)="onClickOutside(true)" (click)="onClickOutside(false)">

            <div *ngIf="f.phone.invalid && (f.phone.dirty || f.phone.touched)" >
              <!-- <div *ngIf="f.phone.errors?.required">Phone is reqired.</div> -->
              <div class="alert alert-danger" *ngIf="f.phone.errors?.minlength">{{'examinee.updateExaminee.errorPhone1' | translate}}</div>
              <div class="alert alert-danger" *ngIf="f.phone.errors?.maxlength">{{'examinee.updateExaminee.errorPhone2' | translate}}</div>
              <div class="alert alert-danger" *ngIf="f.phone.errors?.pattern?.requiredPattern && inValidPhone">{{'examinee.updateExaminee.errorPhone3' | translate}}</div>
            </div>
          </span>
        </div>
        <div class="input-wrapper">
          <span class="input-label">
            <label>{{'examinee.updateExaminee.email' | translate}}</label><span class="required">*</span>
          </span>
          <span class="input-field">
            <input id="email" type="text" maxlength="125" formControlName="emailId"  class="form-control" (keydown.space)="$event.preventDefault()" readonly>
            <div class="col-md-12"
              *ngIf="examineeDetailsForm.controls.emailId.invalid && (examineeDetailsForm.controls.emailId.touched || examineeDetailsForm.controls.emailId.dirty)"
              class="alert alert-danger">
              <div *ngIf="examineeDetailsForm.controls.emailId.errors.required">{{'examinee.updateExaminee.errorEmail1' | translate}}</div>
              <div *ngIf="examineeDetailsForm.controls.emailId.errors.minlength">{{'examinee.updateExaminee.errorEmail2' | translate}}</div>
              <div *ngIf="examineeDetailsForm.controls.emailId.errors.maxlength">{{'examinee.updateExaminee.errorEmail3' | translate}}</div>
              <div *ngIf="examineeDetailsForm.controls.emailId.errors.pattern">{{'examinee.updateExaminee.errorEmail4' | translate}}</div>
            </div>
          </span>
        </div>

        <div class="input-wrapper">
          <span class="input-label">
            <label>{{'examinee.updateExaminee.status.option1' | translate}}</label><span class="required">*</span>
          </span>
          <span class="input-field">
            <!-- <select class="form-control" formControlName="status">
            <option value="true">Active</option>
            <option value="false">Inactive</option>
          </select> -->
            <select aria-placeholder="Status" class="form-control ng-untouched ng-pristine ng-valid" ng-reflect-model="" formControlName="status">
              <!-- [attr.disabled]="true" -->
              <option value="" ng-reflect-value="">{{'examinee.updateExaminee.status.option1' | translate}}</option>
              <option [value]="Status.id == 1 ? 'true' : 'false'" ng-reflect-value="none" *ngFor="let Status of statusList">{{Status.title}}</option>
            </select>
            <div *ngIf="f.status.invalid && (f.status.dirty || f.status.touched)" class="alert alert-danger">
              <div *ngIf="f.status.errors?.required">{{'examinee.updateExaminee.errorStatus1' | translate}}</div>
            </div>
          </span>
        </div>
      </div>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-flat-button [mat-dialog-close]="true" color="" class="btn-primary" aria-label="Save" (click)="editExamineeDetails()"
      [disabled]='(examineeDetailsForm.invalid || isEmailNotValid)'>{{'examinee.updateExaminee.btnSave' | translate}}</button>
  </mat-dialog-actions>
</div>



<!-- ********************************************************** -->


<!-- <div class="main-content-wrapper item-bank-details-container">
 <div class="content-wrapper">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="filter-section">
            <button mat-raised-button (click)='navigateToLandingPage()'>
              <i class="fa fa-angle-left"></i>
              <span> Back</span>
            </button>
          </div>

          <div class="btn-wrapper">
            <button (click)="editExamineeDetails()" mat-raised-button color="accent" class="btn-bg-color"
              [disabled]='examineeDetailsForm.invalid'>Save</button>
          </div>
          <div class="tabs">
            <form [formGroup]="examineeDetailsForm" novalidate>
              <div class="input-class">
                <label>First name<span class="red-asterisk">*</span></label>
                <input type="text" maxlength="31" class="form-control" formControlName="firstName">
                <div *ngIf="f.firstName.invalid && (f.firstName.dirty || f.firstName.touched)" class="alert alert-danger">
                  <div *ngIf="f.firstName.errors?.required"> First name is required. </div>
                  <div *ngIf="f.firstName.errors?.minlength"> Minimum 2 characters required. </div>
                  <div *ngIf="f.firstName.errors?.maxlength">Maximum 30 characters allowed. </div>
                  <div *ngIf="f.firstName.errors?.pattern">Special characters, numbers and blank spaces are not allowed. </div>

                </div>
              </div>
              <div class="input-class">
                <label>Last name<span class="red-asterisk">*</span></label>
                <input type="text" maxlength="31" class="form-control" formControlName="lastName">
                <div *ngIf="f.lastName.invalid && (f.lastName.dirty || f.lastName.touched)" class="alert alert-danger">
                  <div *ngIf="f.lastName.errors?.required"> Last name is required. </div>
                  <div *ngIf="f.lastName.errors?.minlength"> Minimum 2 characters required.  </div>
                  <div *ngIf="f.lastName.errors?.maxlength">Maximum 30 characters allowed.</div>
                  <div *ngIf="f.lastName.errors?.pattern">Special characters, numbers and blank spaces not allowed </div>
                </div>
              </div>
              <div class="input-class">
                <label>Phone</label>
                <input type="text" maxlength="25" class="form-control" formControlName="phone" onkeypress='return event.charCode>-48 && event.charCode<=57'>
                <div class="col-md-12" *ngIf="f.phone.invalid && (f.phone.dirty || f.phone.touched)" class="alert alert-danger">

                  <div *ngIf="f.phone.errors?.minlength"> Minimum 5 characters required. </div>
                  <div *ngIf="f.phone.errors?.maxlength">Maximum 24 characters allowed.</div>
                  <div *ngIf="f.phone.errors?.pattern?.requiredPattern">Phone is invalid.</div>

                </div>
              </div>
              <div class="input-class">
                <label>Email<span class="red-asterisk">*</span></label>
                <input type="email"  class="form-control" formControlName="emailId">
              </div>
              <div class="input-class">
                <label>Status<span class="red-asterisk">*</span></label>
                <select class="form-control" formControlName="status">
                  <option value="true">Active</option>
                  <option value="false">Inactive</option>
                </select>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div> -->
